import axios from "axios";
import { getToken } from "../utility/tokenOperations";
const fetchClient = () => {
  const defaultOptions = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  // Create instance
  let axiosInstance = axios.create(defaultOptions);

  /**  Set the AUTH token for any request*/
  axiosInstance.interceptors.request.use(function (config) {
    let token = getToken();
    config.headers.Authorization = token ? `Bearer ${token}` : "";
    config.headers["Controller"] = sessionStorage.getItem("Controller") ?? "";
    config.headers["Action"] = sessionStorage.getItem("Action") ?? "";
    config.headers["Path"] = sessionStorage.getItem("Path") ?? "";
    config.headers["Location"] = sessionStorage.getItem("userLocation") ?? "";

    // If we're sending FormData, don't force a Content-Type header.
    // Let the browser set the correct multipart boundary (and avoid charset-related issues).
    const isFormData = typeof FormData !== "undefined" && config.data instanceof FormData;
    if (isFormData && config.headers) {
      delete config.headers["Content-Type"];
      delete config.headers["content-type"];
    }
    return config;
  });
  return axiosInstance;
};

export default fetchClient();
